import angular from "angular";

import SubscriptionService from "./SubscriptionService";
import StateCommonSubscriptionService from "./StateCommonSubscriptionService";

import StateDataServiceModule from "../StateDataService";

const mStateDataSvc = new WeakMap();
const mStateCommonSubscriptionSvc = new WeakMap();

class StateEventSubscriptionService extends SubscriptionService {
    constructor($q, StateData) {
        super();

        mStateCommonSubscriptionSvc.set(this, new StateCommonSubscriptionService($q, StateData));
        mStateDataSvc.set(this, StateData);
    }

    getTarget(stateTargetId) {
        return mStateCommonSubscriptionSvc.get(this).getTarget(stateTargetId);
    }
    
    getTargetBatch(stateTargetIds) {
        return mStateCommonSubscriptionSvc.get(this).getTargetBatch(stateTargetIds);
    }
    
    addSubscription(recipientId, stateTargetId) {
        let subAddPromise =
            mStateCommonSubscriptionSvc.get(this)
                .addSubscription(
                    recipientId,
                    stateTargetId,
                    (params) => mStateDataSvc.get(this).addEventSubscription(params),
                    (stModel) => stModel.stateEventSubscribers
                );

        return subAddPromise;
    }

    removeSubscription(recipientId, stateTargetId) {
        let subDelPromise =
            mStateCommonSubscriptionSvc.get(this)
                .removeSubscription(
                    recipientId,
                    stateTargetId,
                    (params) => mStateDataSvc.get(this).removeEventSubscription(params),
                    (stModel) => stModel.stateEventSubscribers
                );

        return subDelPromise;
    }

}

StateEventSubscriptionService.$inject = [ "$q", "StateData" ];

export default angular
    .module("trackerbase-app.services.subscription-data-adapters.state-event-subscription-service",[
        StateDataServiceModule
    ])
    .service("StateEventSubscriptionData", StateEventSubscriptionService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/subscription-data-services/StateEventSubscriptionService.js
// module id = zaHN
// module chunks = 1